// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialProofUniversityFooter-cls1_IO3","cls2":"SocialProofUniversityFooter-cls2_6-U SocialProofUniversityFooter-cls1_IO3"};